// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"c9ef5a4d","787":"f69abaa4","810":"c7b1cb83"}[chunkId] + ".chunk.js";
};